var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7530.44,-502.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-black",
    transform: "matrix(0.145417,0,0,0.186342,7126.92,443.371)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.27659,-1.02637e-15,9.18735e-16,-10.0172,20912.6,5469.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2882.07,505.404L2862.35,505.404C2861.94,505.404 2861.62,505.564 2861.62,505.761C2861.62,505.958 2861.94,506.118 2862.35,506.118L2882.07,506.118C2882.47,506.118 2882.8,505.958 2882.8,505.761C2882.8,505.564 2882.47,505.404 2882.07,505.404Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.27659,-1.02637e-15,9.18735e-16,-10.0172,20912.6,5436.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2882.07,505.404L2862.35,505.404C2861.94,505.404 2861.62,505.564 2861.62,505.761C2861.62,505.958 2861.94,506.118 2862.35,506.118L2882.07,506.118C2882.47,506.118 2882.8,505.958 2882.8,505.761C2882.8,505.564 2882.47,505.404 2882.07,505.404Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.27659,-1.02637e-15,9.18735e-16,-10.0172,20912.6,5501.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2882.07,505.404L2862.35,505.404C2861.94,505.404 2861.62,505.564 2861.62,505.761C2861.62,505.958 2861.94,506.118 2862.35,506.118L2882.07,506.118C2882.47,506.118 2882.8,505.958 2882.8,505.761C2882.8,505.564 2882.47,505.404 2882.07,505.404Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.57e66ac1dba8e9d5faeef833d90b4696.svg";
export { ForwardRef as ReactComponent };